module.exports = __webpack_public_path__ + "media/images/icons/circled-x--transparent-ade4429b42fe14d7c00e8d6426377428.svg";